import { defineAction, enumerated, boolean, object, string } from '~/prix'
import entrepreneurAgentCloseRequest from './entrepreneurAgentCloseRequest.action.json'

const entrepreneurAgentCloseRequestDefinition = defineAction({
    ...entrepreneurAgentCloseRequest,
  input: object({
    entrepreneurCpf: string(),
    reason: enumerated({
        done: 'done',
        canceled: 'canceled'
    })
  }),
  output: object({
    success: boolean()
  })
})

export default entrepreneurAgentCloseRequestDefinition